module.exports = __webpack_public_path__ + "static/media/netherlands-flag.293fc8ab.png";